<template>
  <v-card color="black" class="ma-0">
    <v-toolbar dark flat color="black" class="elevation-0" dense>
      <v-btn text @click="close" icon><v-icon>close</v-icon></v-btn>
      <v-toolbar-title>{{ filename }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text class="pb-2 pr-2 pl-2 pt-0">
      <div v-if="type === 'videos'" class="videoWrapper">
        <html>
          <body style="background-color: rgb(38, 38, 38); height: 100%; width: 100%; overflow: hidden; margin: 0px;">
            <embed width="100%" height="100%" name="plugin" id="plugin" :src="url" type="video/mp4" autoplay>
          </body>
        </html>
        <!-- <iframe width="700" height="500" :src="url" frameborder="0" allowfullscreen controlsList="nodownload"></iframe> -->
      </div>
      <!-- <video v-if="type==='video'" :src="url" controls controlsList="nodownload" autoplay width="800"></video> -->
      <v-img v-if="type === 'photos'" :src="url" max-height="600" contain></v-img>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'MediaPreviewer',
  props: ['url', 'type', 'filename'],
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style>
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.videoWrapper body {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
